/**
 * ============================================================================
 * RK WHATSAPP-TRACKING
 *
 * Die VIP-Stoffzirkel-Seite hat mehrere Schaltflächen zur WhatsApp-Gruppe,
 * die bisher nichts gemeldet haben. Dadurch schrieb Meta der WhatsApp-
 * Kampagne die Newsletter-Anmeldungen aus dem Fuß als Erfolg zu — beide
 * feuerten dasselbe Lead-Event.
 *
 * Hier meldet jeder Klick auf einen Gruppenlink ein eigenes Event
 * (CompleteRegistration), sodass sich die beiden Kampagnen endlich
 * auseinanderhalten lassen.
 *
 * Ehrliche Grenze: Gemessen wird der Klick auf „Zur WhatsApp Gruppe", nicht
 * der tatsächliche Beitritt. Was in WhatsApp danach passiert, sieht niemand
 * von außen. Als Optimierungssignal ist der Klick trotzdem ungleich besser
 * als gar nichts.
 *
 * Powered by René Kress - Crovio · www.crovio.de
 * ============================================================================
 */
(function () {
  'use strict';

  var EVENT    = 'CompleteRegistration';
  var SPEICHER = 'rk_wa_gemeldet';
  var CAPI     = 'https://vanaehlismus-ads.web.app/api/oeffentlich/ereignis';

  // Erkennt Gruppeneinladungen und wa.me-Links.
  function istWhatsappLink(url) {
    if (!url) return false;
    return /^https?:\/\/(chat\.whatsapp\.com|wa\.me|api\.whatsapp\.com)\//i.test(url);
  }

  /* Innerhalb einer Sitzung nur einmal melden: Wer zurückkommt und noch
     einmal klickt, ist kein zweiter Beitritt. */
  function schonGemeldet() {
    try { return sessionStorage.getItem(SPEICHER) === '1'; }
    catch (_) { return false; }
  }

  function merken() {
    try { sessionStorage.setItem(SPEICHER, '1'); }
    catch (_) { /* privater Modus */ }
  }

  function cookie(name) {
    var m = document.cookie.match('(?:^|;)\\s*' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : undefined;
  }

  function neueId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'wa-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function melden() {
    if (schonGemeldet()) return;

    /* Dieselbe Kennung an beide Wege, sonst zaehlt Meta den Klick doppelt. */
    var id = neueId();

    if (typeof fbq !== 'undefined') {
      fbq('track', EVENT, {
        content_name:     'WhatsApp-Gruppe VIP-Stoffzirkel',
        content_category: 'whatsapp_gruppe'
      }, { eventID: id });
    }

    /* Der Server meldet auch dann, wenn der Pixel blockiert ist. Hier haben
       wir keine E-Mail-Adresse — es bleibt bei Metas eigenen Cookies, der IP
       und dem Browser. Das reicht fuer die Zuordnung eines Klicks. */
    try {
      var rumpf = JSON.stringify({
        event_name: EVENT,
        event_id:   id,
        fbp:        cookie('_fbp'),
        fbc:        cookie('_fbc'),
        quelle:     location.href
      });
      /* sendBeacon, weil der Klick die Seite gleich verlaesst. */
      if (navigator.sendBeacon) {
        navigator.sendBeacon(CAPI, new Blob([rumpf], { type: 'application/json' }));
      } else {
        fetch(CAPI, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: rumpf,
          keepalive: true
        }).catch(function () {});
      }
    } catch (_) { /* der Pixel hat schon gemeldet */ }

    merken();
  }

  // Ein Zuhörer am Dokument statt einer je Schaltfläche — so greift es auch
  // bei Links, die erst später dazukommen.
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href]') : null;
    if (!link) return;
    if (!istWhatsappLink(link.getAttribute('href'))) return;
    melden();
  }, true);

})();
